<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Ingreso de Factura de Compra Manualmente</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Compras</span>
      <span> /</span>
      <span>Ingreso de Factura de Compra Manualmente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow">
    <!--Card content-->
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect (click)="OpenagregarDoc()">Agregar
          documento</button>
      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" formControlName="fechaDesde" [placeholder]="'Desde'"
              required> </mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" formControlName="fechaHasta" [placeholder]="'Hasta'"
              required> </mdb-date-picker>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn color="secondary" size="sm" mdbWavesEffect type="submit" (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>
<!-- Cabecera de botones -->
<div class="card mb-2 wow" *ngIf="listaMovimientos != null">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Rut</th>
            <th scope="col">Proveedor</th>
            <th scope="col">Folio</th>
            <th scope="col">Fecha Emi.</th>
            <th scope="col">Fecha Venc.</th>
            <th scope="col">Monto afecto</th>
            <th scope="col">Monto exento</th>
            <th scope="col">Monto Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">No se
              encontró información</td>
          </tr>
          <tr *ngFor="let doc of listaMovimientos">
            <td>{{ doc.rutFormato | rut }}</td>
            <td>{{ doc.cliente_proveedor_nombre }}</td>
            <td>{{ doc.folio}}</td>
            <td>{{ doc.fecha_recepcion | fecha}}</td>
            <td>{{ doc.fecha_vencimiento | fecha}}</td>
            <td>{{ doc.monto_afecto | numerico}}</td>
            <td>{{ doc.monto_exento | numerico}}</td>
            <td>{{ doc.monto_total | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>


<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('PDF')">
      PDF
    </button>
  </div>
</div>


<!-- MODAL AGREGAR PRODUCTO -->
<app-modal-agregar-documento (onExecuteBuscar)="getItemToSearch($event)"></app-modal-agregar-documento>
